import {Avatar} from '@mui/material';
import styled from 'styled-components';

export const EntityOption = styled.div`
  display: flex;
  align-items: center;
`;

interface AvatarImageProps {
  size: string;
}

export const AvatarImage = styled(Avatar)<AvatarImageProps>`
  && {
    width: ${props => (props.size === 'small' ? 16 : 20)}px;
    height: ${props => (props.size === 'small' ? 16 : 20)}px;
  }
  margin-right: 8px;
  img {
    object-fit: contain;
  }
`;
